import Router from "next/router";
import { useEffect, useState } from "react";
import { useSession } from "next-auth/react";
import Cookie from "js-cookie";
import Script from "next/script";
import CookieConsent from "src/Candidate/molecules/CookieConsent";
import LandingPageBackground from "@/admin/molecules/LandingPageComponents/LandingPageBackground";
import HomeHeader from "./seoComponent";

function Home(): JSX.Element {
  const { status } = useSession();
  const [showConsent, setShowConsent] = useState<any>(true);
  const cookieValue = Cookie.get("cookiePolicy");

  useEffect(() => {
    // const acceptedCookies = localStorage.getItem("acceptedCookies");
    if (cookieValue) {
      const browserData = JSON.parse(cookieValue);
      if (browserData.cookiesEnables === true) {
        setShowConsent(false);
      } else if (browserData.cookiesEnables === undefined) {
        setShowConsent(true);
      } else {
        setShowConsent(false);
      }
    }
  }, []);

  if (status === "authenticated") {
    Router.replace(
      {
        pathname: "/candidate/course-library/my-courses/all-courses",
      },
      "/candidate/course-library/my-courses/all-courses"
    );
  } else {
    return (
      <>
        <HomeHeader title="MyEdVault Home Page" />
        <div className="w-full h-screen ">
          <Script
            strategy="lazyOnload"
            src="https://embed.tawk.to/6877fdff3606072bf84a2cf9/1j0abgbbv"
          />
          <LandingPageBackground />
          {showConsent && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-50">
              <div
                onClick={() => setShowConsent(false)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setShowConsent(false);
                }}
                role="button"
                tabIndex={0}
                className="absolute inset-0"
              />
              <div className="relative">
                <CookieConsent
                  onResponse={() => {
                    setShowConsent(false);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  return (
    <div className="flex place-content-center h-screen">
      <div className="self-center">Loading...</div>
    </div>
  );
}

export default Home;
